var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Promise as P } from "bluebird";
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";
import React, { useRef } from "react";
import { __uploaderClientRest, __uploaderClientRestStream, } from "./request.rest";
export const getFileNameFromFullName = (fullName) => fullName.substr(0, fullName.indexOf("."));
export const getFileExtensionFromFileName = (fileName) => fileName.substring(fileName.lastIndexOf("."));
const generateFileWithName = (file) => new File([file], `${new Date().toISOString().split(".")[0]}-${file.name}`, {
    type: file.type,
});
const concurrency = 10;
export const handleFileUploadInChunks = (options) => {
    return (files) => __awaiter(void 0, void 0, void 0, function* () {
        yield P.map(files, (file) => __awaiter(void 0, void 0, void 0, function* () {
            const fileData = generateFileWithName(file);
            yield __uploaderClientRestStream(Object.assign(Object.assign({}, options), { fileName: fileData.name, originalName: file.name }))(fileData);
        }), { concurrency });
    });
};
export const handleFileUpload = (options) => {
    return (files) => __awaiter(void 0, void 0, void 0, function* () {
        yield P.map(files, (file) => __awaiter(void 0, void 0, void 0, function* () {
            const fileData = generateFileWithName(file);
            yield __uploaderClientRest(Object.assign(Object.assign({}, options), { fileName: fileData.name, originalName: file.name }))(fileData);
        }), { concurrency });
    });
};
export const handleMultipleFileUploads = (options) => {
    return (files) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const fileArray = Array.from(files);
        (_a = options.onLoadMultiple) === null || _a === void 0 ? void 0 : _a.call(options, fileArray);
        yield Promise.all(Array.from(files).map((f) => __uploaderClientRest(Object.assign(Object.assign({}, options), { fileName: getFileNameFromFullName(f.name) }))(f)));
    });
};
export const handleFileUploadWithOverride = (options) => {
    return (files) => (overrideOptions) => __awaiter(void 0, void 0, void 0, function* () {
        yield P.map(files, (file) => __awaiter(void 0, void 0, void 0, function* () {
            yield __uploaderClientRest(Object.assign(Object.assign(Object.assign({}, options), { fileName: getFileNameFromFullName(file.name) }), omitBy(overrideOptions, isNil)))(file);
        }));
    });
};
export const withFileUpload = (p) => (WrappedComponent) => (_a) => {
    var props = __rest(_a, []);
    const { fileTypes, onLoad, multiple = false, beforeUpload } = p;
    const inputFileRef = useRef(null);
    const showFileDialog = () => { var _a; return (_a = inputFileRef.current) === null || _a === void 0 ? void 0 : _a.click(); };
    const acceptTypes = fileTypes === null || fileTypes === void 0 ? void 0 : fileTypes.join(", ");
    const handleOnLoad = (file) => onLoad ? onLoad(file || undefined) : undefined;
    return (React.createElement("div", { role: "button", onClick: (e) => {
            e.stopPropagation();
            showFileDialog();
        }, onKeyDown: (e) => {
            e.stopPropagation();
            showFileDialog();
        }, tabIndex: 0 },
        React.createElement("input", { style: { display: "none" }, ref: inputFileRef, type: "file", accept: acceptTypes, multiple: multiple, onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                if (e.target.files) {
                    if (beforeUpload) {
                        beforeUpload(handleFileUploadWithOverride(Object.assign(Object.assign({}, p), { onLoad: () => {
                                var _a, _b;
                                return handleOnLoad((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.item(0));
                            } })), Array.from(e.target.files));
                    }
                    else if (multiple) {
                        handleMultipleFileUploads(Object.assign(Object.assign({}, p), { onLoad: (f) => handleOnLoad(f) }))(Array.from(e.target.files));
                    }
                    else {
                        handleFileUpload(Object.assign(Object.assign({}, p), { onLoad: () => { var _a, _b; return handleOnLoad((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.item(0)); } }))(Array.from(e.target.files));
                    }
                }
            }) }),
        React.createElement(WrappedComponent, Object.assign({}, props))));
};
//# sourceMappingURL=withFileUpload.js.map